import { isPlatformServer } from '@angular/common';
import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Constants } from 'src/app/common/Constants';
import { MessageService } from 'src/app/common/message.service';
import { HTTPService } from 'src/app/services/http.service';
import { SharedService } from 'src/app/services/shared.service';
import { PreviewCardExperienceComponent } from '../preview-card-experience/preview-card-experience.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-preview-card',
  templateUrl: './preview-card.component.html',
  styleUrls: ['./preview-card.component.scss'],
  providers: [HTTPService, MessageService],
})
export class PreviewCardComponent implements OnInit {
  subscription = new Subscription();
  @Input() cardId = 0;
  @Input() categoryId: number;
  @Input() subCategoryId: number;
  public messageType: any;
  public VideoFilterModel = {
    cardId: 0,
    categoryId: 0,
    SubcategoryId: 0,
    StartRow: 0,
    PageSize: 1200,
    ScreenType: 1,
    IsMainHomePageRequest: false,
  };
  public constants: Constants;
  currentCard: any;
  previewImagePath: string;
  envelopeImagePath: string;
  isDataLoaded: boolean = false;
  similiarCardData: any;
  userDetails: any = {};
  constructor(
    public activeModal: NgbActiveModal,
    private _route: ActivatedRoute,
    private dialog: MatDialog,
    private _httpService: HTTPService,
    private messageService: MessageService,
    public sharedService: SharedService,
    private _router: Router,
    @Inject(PLATFORM_ID) private platformId
  ) {
    this.constants = new Constants();
    this.messageType = this.constants.messageType;
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
  }

  ngOnInit(): void {
    // this.subscription.add(
    //   this._route.paramMap.subscribe((params) => {
    //     const queryData = this.sharedService.decryptAndParseQueryString(params.get("data"));
    //     if (queryData != undefined) {
    //       this.cardId = queryData.cardId;
    //       this.categoryId = queryData.categoryId;
    //       this.subCategoryId = queryData.subCategoryId;
    //       if (this.cardId > 0)
    //         this.loadCardData();
    //     }
    //   })
    // );
    // if (!isPlatformServer(this.platformId)) {
    //   this._router.events.subscribe((evt) => {
    //     if (!(evt instanceof NavigationEnd)) {
    //       return;
    //     }
    //     window.scrollTo(0, 0)
    //   });
    // }
    if (this.cardId > 0) {
      this.loadCardData();
    }
  }
  ngAfterViewInit() {
    this.sharedService.isShowLoader.next(true);
  }
  loadCardData() {
    // this.VideoFilterModel.cardId = this.cardId;
    this.sharedService.isShowLoader.next(true);
    this.VideoFilterModel.categoryId = this.categoryId;
    this.VideoFilterModel.SubcategoryId = this.subCategoryId;
    this.subscription.add(
      this._httpService
        .ajaxPost('homepage/GetHomepageData', this.VideoFilterModel)
        .subscribe(
          (data) => {
            if (
              data['Message'].MessageTypeValue == this.messageType.Success ||
              data['Message'].MessageTypeValue == 6
            ) {
              var allCardData = data['AllCardData'];
              this.currentCard = allCardData.filter(
                (x) => x.CardId == this.cardId
              )[0];
              this.similiarCardData = allCardData.filter(
                (x) => x.CardId !== this.cardId
              );
              this.previewImagePath =
                this._httpService.baseURL + this.currentCard.PreviewImage;
              this.envelopeImagePath =
                this._httpService.baseURL + this.currentCard.EnvelopeImage;
            } else {
              this.messageService.showMessage(
                data['Message'].Text,
                data['Message'].MessageTypeValue
              );
            }
            this.sharedService.isShowLoader.next(false);
            this.isDataLoaded = true;
            this.sharedService.isShowLoader.next(false);
            if (!isPlatformServer(this.platformId)) window.scrollTo(0, 0);
          },
          (error: any) => {
            this.sharedService.isShowLoader.next(false);
            this.isDataLoaded = true;
            this.sharedService.isShowLoader.next(false);
            // this.hideSpinner();
            // this.messageService.showMessage(this.constErrors.CommonError, this.messageType.Error);
          }
        )
    );
  }
  // GoToPersonalizeCard() {
  //   this.sharedService.isShowLoader.next(true);
  //   let objLog = Object.assign({});
  //   objLog.UserId = this.userDetails?.UserId == null ? 0 : this.userDetails?.UserId;
  //   objLog.MethodName = "Customise Card";
  //   objLog.IsSuccess = true;
  //   objLog.Description = "User clicked customized card";
  //   objLog.IPAddress = this.sharedService.ipAddress;
  //   this.subscription.add(
  //     this._httpService.ajaxPost('Personalize/AddLog', objLog).subscribe((data) => {
  //       this.sharedService.isShowLoader.next(false);
  //       this._router.navigate([`/personalise/${this.currentCard?.NameEnglish.replace(/ +/g, "-")}/card/${this.cardId}`]);
  //     }));
  //   // this._router.navigate(['/personalizecard', { CardId: this.cardId }]);

  // }
  openPreviewExperience(): void {
    const modelRef = this.dialog.open(PreviewCardExperienceComponent, {
      width: '100%',
    });
    modelRef.componentInstance.videoPath = this.currentCard.VideoFilePath;
  }
  goBack() {
    let encryptedqueryparams: { categoryId: any; subCategoryId: any };
    encryptedqueryparams = {
      categoryId: this.categoryId,
      subCategoryId: this.subCategoryId,
    };
    this._router.navigate([
      `/category/subcategory/cards-invitation-maker/${this.sharedService.encryptData(
        JSON.stringify(encryptedqueryparams)
      )}`,
    ]);
  }
  closeCardPreview() {
    this.activeModal.close();
  }
}
